import { createSelector } from '@reduxjs/toolkit';
import { userWorkspaceManagerRight } from '../hooks/useWorkspaceManagerRight';
import { getMyWorkspaceSelector } from '../../workspace/selectors/Workspace.selectors';
import RightsApi from '../RightsAPI';

const getMyRightsSelector = createSelector(
  [RightsApi.endpoints.getMyRights.select(undefined)],
  (rightsResponse) => rightsResponse.data || []
);

export const getIsManagerRoleSelector = createSelector(
  [getMyRightsSelector, getMyWorkspaceSelector],
  (allRights, workspace) => {
    if (!workspace) {
      return false;
    }
    return userWorkspaceManagerRight(workspace, allRights);
  }
);
